import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * ManageSubjects - Wrapper
 */
const ManageSubjects = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-manage-subjects',
      // styles
      'flex flex-wrap gap-10 rounded-xl bg-white p-5 shadow-dropshadow',
      className
    )}
    {...props}
  />
));
ManageSubjects.displayName = 'ManageSubjects';

/**
 * ManageSubjectsSidebar - Coluna lateral
 */
const ManageSubjectsSidebar = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-manage-subjects-sidebar',
      // styles
      'w-full max-w-full md:w-[13.75rem] md:border-r md:border-solid md:border-neutral-lightest md:pr-10',
      className
    )}
    {...props}
  />
));
ManageSubjectsSidebar.displayName = 'ManageSubjectsSidebar';

/**
 * ManageSubjectsContent - Área de conteúdo
 */
const ManageSubjectsContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-manage-subjects-content',
      // styles
      'w-[7.5rem] flex-grow md:mt-[5.375rem]',
      className
    )}
    {...props}
  />
));
ManageSubjectsContent.displayName = 'ManageSubjectsContent';

export { ManageSubjects, ManageSubjectsSidebar, ManageSubjectsContent };
